import React from "react";

const Header = () => {
    return <header>
        <h1>React Do It!</h1>
    </header>
}

export default Header;